export default function just<T>(o: T): T {
    return o;
}
